export default class Video {
    
    static get selector() {
        return '.actionSlider__video';
    }

    constructor(el) {
        this.isActive = false;
        this.loadScript();
        this.el = el;
        this.link = el.querySelector('.actionSlider__videoLink');
        this.id = this.el.dataset.id;
        this.setEvents();
    }

    init() {
        if(!this.isActive) {
            this.isActive = true;
            this.createContainer();
            this.player = new YT.Player(this.playerElement, {
                height: '100%',
                width: window.innerWidth,
                videoId: this.id,
                playerVars: {
                    
                    rel:0,
                    fs:1,
                    modestbranding: 1,
                    showinfo: 0,
                    controls: 2,
                    disablekb: 1
                },
                events: {
                'onReady': this.onPlayerReady.bind(this),
                'onStateChange': this.onPlayerStateChange
                }
            });
        }
    }

    onPlayerReady() {
        this.lightbox.classList.add('videoLightbox--active');
        this.lightbox.classList.remove('videoLightbox--loading');

        this.player.playVideo();//won't work on mobile
    }

    onPlayerStateChange() {

    }

    createContainer() {
        this.lightbox = document.createElement('div');
        this.lightbox.classList.add('videoLightbox');
        this.lightbox.classList.add('videoLightbox--loading');
        this.lightbox.addEventListener('click', this.e_close.bind(this));


        document.addEventListener("keydown", (e) => {
            if(e.which == 27) this.e_close();
        })

        this.playerContainer = document.createElement('div');
        this.playerContainer.classList.add('videoLightbox__container');

        this.lightboxClose = document.createElement('button');
        this.lightboxClose.innerText = 'Close';
        this.lightboxClose.classList.add('videoLightbox__close');
        this.lightboxClose.addEventListener('click', this.e_close.bind(this));
        this.playerContainer.appendChild(this.lightboxClose);


        this.playerElement = document.createElement('div');
        this.playerElement.classList.add('videoLightbox__player');
        this.playerContainer.appendChild(this.playerElement);
        this.lightbox.appendChild(this.playerContainer);

        document.body.appendChild(this.lightbox);
    }
    

    setEvents() {
        this.link.addEventListener('click', this.e_click.bind(this));
    }

    e_close(e) {
        this.player.pauseVideo();
        this.lightbox.classList.remove('videoLightbox--active');
        setTimeout(()=>{
            this.lightbox.parentElement.removeChild(this.lightbox);
            this.isActive = false;
        }, 600);
    }

    e_click(e) {
        e.preventDefault();
        if(window.youtubeLoaded) this.init();
        else window.addEventListener('fondation-youtubeloaded', this.e_youtubeAPIloaded.bind(this));
    }

    e_youtubeAPIloaded() {
        this.init();
    }

    loadScript() {
        var tag = document.createElement('script');

        tag.src = "https://www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

}